import { Component, Input } from '@angular/core';
import { SnapshotResponse } from '../../../models/analytics.model';

@Component({
    selector: 'app-analytics-kpi-cards',
    templateUrl: './analytics-kpi-cards.component.html',
    styleUrls: ['./analytics-kpi-cards.component.scss'],
})
export class AnalyticsKpiCardsComponent {
    @Input() snapshot: SnapshotResponse;
    @Input() comparePrevious = false;

    get slaDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.slaCompliance?.previousRate === undefined) {
            return null;
        }
        return +(this.snapshot.slaCompliance.rate - this.snapshot.slaCompliance.previousRate).toFixed(1);
    }

    get resolutionDelta(): number | null {
        if (!this.comparePrevious || this.snapshot?.avgResolutionTime?.previousDays === undefined) {
            return null;
        }
        return +(this.snapshot.avgResolutionTime.days - this.snapshot.avgResolutionTime.previousDays).toFixed(1);
    }
}
